import { render, staticRenderFns } from "./DialogDetailCard.vue?vue&type=template&id=6b2a9abe"
import script from "./DialogDetailCard.vue?vue&type=script&lang=js"
export * from "./DialogDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports